import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import './CassaTicketPage.css';

interface OrderItem {
  id: number;
  prodotto_id: number;
  nome_prodotto: string;
  quantita: number;
  prezzo_unitario: number;
}

interface Ordine {
  id: number;
  session_id: string;
  stato: string;
  totale: number;
  metodo_pagamento: string;
  numero_progressivo: number;
  data_ordine: string;
  items: OrderItem[];
}

const CassaTicketPage: React.FC = () => {
  const { token } = useAuth();
  const [ordini, setOrdini] = useState<Ordine[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchOrdini = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL || '/api'}/ordini/da-evadere`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setOrdini(res.data);
      setError(null);
    } catch (err: any) {
      console.error('Errore nel caricamento ordini:', err);
      setError('Impossibile caricare i ticket. Riprova più tardi.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrdini();
    // Polling ogni 5 secondi per vedere i nuovi ticket (in un'app reale si userebbero i WebSocket)
    const intervalId = setInterval(fetchOrdini, 5000);
    return () => clearInterval(intervalId);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- polling avviato una tantum al mount
  }, []);

  const handleConsegna = async (id: number) => {
    try {
      // Mostra un feedback immediato nascondendo l'ordine
      setOrdini(ordini.filter(o => o.id !== id));
      
      await axios.post(`${process.env.REACT_APP_API_URL || '/api'}/ordini/${id}/consegna`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
    } catch (err: any) {
      console.error('Errore consegna ordine:', err);
      alert('Errore durante la chiusura del ticket. Riprova.');
      fetchOrdini(); // Ricarica la lista per sicurezza
    }
  };

  if (loading && ordini.length === 0) return <div className="loading-state">Caricamento ticket in corso...</div>;

  return (
    <div className="cassa-ticket-page">
      <div className="page-header">
        <h1>Ticket da Consegnare</h1>
        <div className="ticket-count">
          {ordini.length} {ordini.length === 1 ? 'ticket in attesa' : 'ticket in attesa'}
        </div>
      </div>

      {error && <div className="error-message">{error}</div>}

      <div className="ticket-grid">
        {ordini.length === 0 ? (
          <div className="empty-state">
            Nessun ticket in attesa.
          </div>
        ) : (
          ordini.map((ordine) => (
            <div key={ordine.id} className="ticket-card">
              <div className="ticket-header">
                <h2>#{ordine.numero_progressivo}</h2>
                <span className={`payment-badge ${ordine.metodo_pagamento}`}>
                  {ordine.metodo_pagamento === 'stripe' ? 'QR Code (Stripe)' : 'POS (Nexi)'}
                </span>
              </div>
              
              <div className="ticket-items">
                {ordine.items && ordine.items.filter(i => i != null).map((item, idx) => (
                  <div key={idx} className="ticket-item">
                    <span className="item-qty">{item.quantita}x</span>
                    <span className="item-name">{item.nome_prodotto}</span>
                  </div>
                ))}
              </div>
              
              <div className="ticket-footer">
                <div className="ticket-time">
                  {new Date(ordine.data_ordine).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                </div>
                <button 
                  className="deliver-btn"
                  onClick={() => handleConsegna(ordine.id)}
                >
                  CONSEGNATO (3 Tap)
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default CassaTicketPage;
